import { action } from 'mobx';
import { createActor } from 'xstate';

import { SelectOption, AgeDistributionResponse } from 'types';

import { BaseChartStore } from '../../base-chart-store';
import { AgeDistribution } from '../age-distribution.model';
import { AgeDistributionSerializer } from '../serializer';

export class AgeDistributionStore extends BaseChartStore<
  AgeDistribution,
  AgeDistributionResponse
> {
  constructor(private serializer: AgeDistributionSerializer) {
    super('Age Distribution Machine');
    // extend base chart machine if necessary
    this.service = createActor(this.machine);
    this.service.subscribe((state) => {
      this.current = state;
    });
    this.service.start();
  }

  protected async doFetch(
    therapists: SelectOption<string>[],
    partnerId: string,
    partners: Array<SelectOption<string>>,
    clinics: Array<SelectOption<string>>,
    time: string,
    signal?: AbortSignal,
  ): Promise<AgeDistribution> {
    const jsonResponse = await this.load(
      'age_distribution',
      {
        therapists,
        partnerId,
        partners,
        clinics,
        time,
      },
      signal,
    );
    return this.serializer.deserialize(jsonResponse);
  }
}
